import { useMutation, useQueryClient } from '@tanstack/react-query';
import { userActivation } from '../../api';
import { useAlert } from '../useAlert';

export default function useUserActivation() {
  const { showAlert } = useAlert();
  const queryClient = useQueryClient();
  const memberDeleteRequest = useMutation({
    mutationFn: userActivation,
    mutationKey: 'userActivation',
    onSuccess: ({ data }) => {
      queryClient.invalidateQueries('getUsers');
      showAlert({
        type: 'success',
        message: data?.message ?? 'Status changed sucessfully',
      });
    },
    onError: (error) => {
      const errMsg = error?.message ?? 'unexpected error';
      showAlert({ type: 'secondary', message: errMsg });
    },
  });
  return { ...memberDeleteRequest };
}
